import React, { useState } from 'react'
import PropTypes from 'prop-types'
import FormModal from './form-modal'
import Table from './table'
import Pagination from '../pagination'

function PushNotifications(props) {
  const [showModal, setShowModal] = useState(false)

  const createPushNotification = (params) => {
    setShowModal(false)
    props.onCreate(params)
  }

  return <div className='wrapper'>
    <h2>Push Notifications</h2>

    <a className='btn btn-success clickable' onClick={() => setShowModal(true)}>
      <i className='fa fa-plus'></i>&nbsp;
      New push notification
    </a>
    <Pagination 
      page={props.page} 
      perPage={props.perPage}
      totalCount={props.total}
      setPage={props.setPage}
      setPerPage={props.setPerPage}
    />
    <Table notifications={props.sentNotifications}/>
    { showModal && <FormModal regions={props.regions} onClose={() => setShowModal(false)} onCreate={createPushNotification} /> }
  </div>
}

PushNotifications.propTypes = {
  regions: PropTypes.array.isRequired,
  sentNotifications: PropTypes.array.isRequired,
  onCreate: PropTypes.func.isRequired,
  page: PropTypes.number,
  perPage: PropTypes.number,
  total: PropTypes.number,
  setPage: PropTypes.func,
  setPerPage: PropTypes.func,
}

export default PushNotifications
